import React, { useEffect, useState } from 'react'
import { useQnaHook } from '../useQnaHook';
import QnaListComponent from './QnaListComponent';
import InfiniteScrollSentinel from '../../Blogs/components/InfiniteScrollSentinel';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../Store/store';
import DeleteQnaModal from './DeleteQnaModal';
import { setDeleteModalVisibleRedux, setQnaReplyModalVisibleRedux, setSelectedQnaIdRedux, setSelectedQnaTitleRedux } from '../../../Store/slices/qnaSlice';
import QnaReplyModal from './ReplyQnaModal';

export default function ListQna() {
    const {
        deleteModalVisible,
        qnaReplyModalVisible,
        selectedQnaId,
        selectedQnaTitle,
        qnaReplyString,
    } = useSelector((state: RootState) => state.qna.value);
    const dispatch = useDispatch();
    const {
        fetchQnas,
        fetchMoreQnas,
        searchQnas,
        qnas,
        qnaLoading,
        deleteQnaFromAdminSide,
        replyQnaFromAdminSide,
        loadingMore,
        hasMoreQnas,
    } = useQnaHook();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetchQnas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchQnas();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchQnas(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);

    if (qnas === null || qnaLoading === true) {
        return (
            <div>Loading...</div>
        )
    }
    return (
        <div className='flex flex-col items-center'>
            <p className='text-2xl font-bold mb-4'>QnA List</p>
            <hr className='w-1/2 mb-4' />
            
            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search QnA... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                qnas.map((qna: any) => {
                    return (
                        <QnaListComponent
                            onReplyClick={() => {
                                dispatch(setQnaReplyModalVisibleRedux(true))
                                dispatch(setSelectedQnaIdRedux(qna._id))
                                dispatch(setSelectedQnaTitleRedux(qna.qnaTitle))
                            }}
                            onDeleteClick={() => {
                                dispatch(setDeleteModalVisibleRedux(true))
                                dispatch(setSelectedQnaIdRedux(qna._id))
                                dispatch(setSelectedQnaTitleRedux(qna.qnaTitle))
                            }}
                            key={qna._id}
                            _id={qna._id}
                            qnaTitle={qna.qnaTitle}
                            qnaQuestion={qna.qnaQuestion}
                            qnaReplyCount={qna.qnaReplyCount}
                            qnaCreatedAt={qna.qnaCreatedAt}
                            qnaUpdatedAt={qna.qnaUpdatedAt}
                            replyEnabled={qna.replyEnabled}
                            qnaReplies={qna.qnaReplies}
                            isDeleted={qna.isDeleted}
                            isPriority={qna.isPriority}
                        />
                    )
                })
            }
            {searchQuery.trim() === '' && hasMoreQnas && (
                <>
                    <InfiniteScrollSentinel
                        onLoadMore={fetchMoreQnas}
                        disabled={loadingMore}
                    />
                    {loadingMore && <p className="py-4 text-gray-500">Daha fazla yükleniyor...</p>}
                </>
            )}
            {
                deleteModalVisible === true
                    ? <DeleteQnaModal
                        visible={deleteModalVisible}
                        onClose={() => {
                            dispatch(setSelectedQnaIdRedux(''))
                            dispatch(setSelectedQnaTitleRedux(''))
                            dispatch(setDeleteModalVisibleRedux(false))
                        }}
                        selectedQnaTitle={selectedQnaTitle}
                        onClickDelete={() => deleteQnaFromAdminSide(selectedQnaId)}
                    />
                    : null
            }
            {
                qnaReplyModalVisible === true
                    ? <QnaReplyModal
                        visible={qnaReplyModalVisible}
                        onClose={() => {
                            dispatch(setSelectedQnaIdRedux(''))
                            dispatch(setSelectedQnaTitleRedux(''))
                            dispatch(setQnaReplyModalVisibleRedux(false))
                        }
                        }
                        selectedQnaTitle={selectedQnaTitle}
                        onClickSend={() => replyQnaFromAdminSide(selectedQnaId, qnaReplyString)}
                    />
                    : null
            }
        </div>
    )
}
